const isPrerender = (): boolean => Boolean(navigator.userAgent && navigator.userAgent.indexOf('Prerender') >= 0);

export default isPrerender;
